<script setup lang="ts">
interface Props {
    mode?: "number" | "blue";
    disableScroll?: boolean;
}

defineProps<Props>();
const emit = defineEmits(["click"]);
</script>

<template>
    <div :class="['Tile', mode]" @click="emit('click', $event)">
        <card :disableScroll="disableScroll">
            <div class="tile-content">
                <slot />
            </div>
        </card>
    </div>
</template>

<style lang="scss">
.Tile {
    min-width: 280px;
    width: auto;
    margin-bottom: $padding !important;
    .Card {
        border-radius: 12px;
        box-shadow: 0 12px 9px 0 rgba(0, 0, 0, 0.12);
        width: 96%;
        height: 100%;
    }
    .card-content {
        padding: 0 !important;
        height: 100%;
        user-select: none;
    }
    .tile-content {
        height: 100%;
        .section {
            background: $lightgrey3;
            padding: 6px;
            border-bottom: 1px solid $white;

            &:last-child {
                border-bottom: none;
            }

            & > div {
                &:last-child {
                    margin-bottom: 0;
                }
            }

            &.head {
                font-size: 16px;
                &:first-letter {
                    text-transform: capitalize;
                }
            }
        }
        .bottom {
            background: $lightblue2;
            font-size: 12px;
            color: #5a87b8;
            font-weight: $medium;
            transition: 0.2s linear;
            padding: 0;

            .bottom-head {
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px solid $lightgrey2;
                height: 25px;
                gap: 5px;
                padding: 0 5px;

                .Icon {
                    &,
                    svg {
                        height: 10px;
                        width: 10px;
                        fill: $darkblue;
                    }
                }
            }
            .section {
                background: transparent;
                padding: 0;
                border-color: $lightgrey2;
            }
        }
    }

    &.number {
        min-width: 300px;
        min-height: 160px;
        .tile-content {
            border-left: none;
            border-bottom: 10px solid $purple;
            background: $lightgrey2;
            padding: calc($padding / 2);

            .label {
                justify-content: center;
                color: $black;
                font-size: 18px;
                padding-bottom: calc($padding / 3);
            }

            .value {
                display: flex;
                align-items: center;
                justify-content: center;
                overflow: hidden;
                color: $purple;
                font-weight: $thin;
                font-size: 80px;
                white-space: nowrap;
                width: 100%;
                height: calc(100% - 35px);
            }
        }
    }

    &.blue {
        .Card {
            border: none !important;
            box-shadow: none !important;
        }
        .section {
            background: $lightblue2;
            color: $paleblue;
            font-weight: $medium;
        }
    }
}
</style>
